import { Component, Input } from '@angular/core';

/**
 * The portal's plain page header — the mockup's `.top` row.
 *
 * Every AGU Member Hub screen opens the same way: a 27px/800 title on the
 * left, an optional tag pill inline beside it, an optional sub line beneath it,
 * and a right-hand slot holding either a date line or the page's actions. There
 * is deliberately NO header band and NO eyebrow above the title on these
 * screens (parity/home.md §2) — the finder screens' banded header is a
 * different object, and giving this one a band is the single easiest way to
 * lose the mockup's feel.
 *
 * Two ways in for the sub line, because the two callers genuinely differ: Saved
 * / Search / Settings pass a plain sentence through `Sub`, while Home's
 * greeting sub is rich (bold run counts and real navigation buttons built from
 * `HomeGreeting.bodyParts`) and is projected into the `[sub]` slot instead. The
 * same split is why `[tag]` and `[actions]` are slots rather than inputs: a tag
 * pill's colour and an action's click handler belong to the page, not here.
 *
 * Source of truth: plans/research-accelerator/mockups/screens/home.html `.top`,
 * tabulated in plans/research-accelerator/mockups/parity/home.md §4.2.
 */
@Component({
    standalone: false,
    selector: 'agu-plain-header',
    templateUrl: './plain-header.component.html',
    styleUrl: './plain-header.component.scss',
})
export class AGUPlainHeaderComponent {
    /** The page title, rendered as the screen's `h1`. */
    @Input({ required: true }) Title!: string;
    /** One plain sentence under the title. Null renders no element — project into `[sub]` for a rich sub line instead. */
    @Input() Sub: string | null = null;
    /** The right-hand date line ("Today is Wednesday, 19 August 2026"). Null renders no element. */
    @Input() Date: string | null = null;
}
